import CarSearch from './car-search';

function init() {
  CarSearch.init();  
}

export { init };
